import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowRight, Layers, Code, Link as LinkIcon, ExternalLink, MessageSquare, Phone, Mail, Database, RefreshCw, Calendar } from 'lucide-react';
export const Integrations = () => {
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-558">
      <Navbar data-id="element-559" />
      <main data-id="element-560">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-24 lg:py-32" data-id="element-561">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.05)_0,_transparent_70%)]" data-id="element-562"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-563"></div>
          {/* Decorative elements */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/5 rounded-full filter blur-3xl" data-id="element-564"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-zinc-800/20 rounded-full filter blur-3xl" data-id="element-565"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-566">
            <div className="max-w-4xl mx-auto text-center" data-id="element-567">
              <div className="inline-block px-4 py-1 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-6" data-id="element-568">
                <span className="font-['Playfair_Display'] text-zinc-400 text-sm tracking-wider" data-id="element-569">
                  SEAMLESS CONNECTIVITY
                </span>
              </div>
              <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-light mb-8 leading-tight" data-id="element-570">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-zinc-400" data-id="element-571">
                  Integrations
                </span>
              </h1>
              <p className="font-['Space_Grotesk'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-572">
                Connect our AI solution with your existing systems to create a
                unified workflow that enhances your firm's efficiency.
              </p>
            </div>
          </div>
        </section>
        {/* Main Content */}
        <section className="relative py-20" data-id="element-573">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0,_transparent_50%)]" data-id="element-574"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-575">
            <div className="max-w-4xl mx-auto" data-id="element-576">
              {/* Introduction Section */}
              <div className="mb-24 relative" data-id="element-577">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-578"></div>
                <div className="bg-gradient-to-br from-zinc-900/80 to-black/80 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-579">
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-8" data-id="element-580">
                    Designed for{' '}
                    <span className="text-white" data-id="element-581">Seamless Integration</span>
                  </h2>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-582">
                    Our platform was designed to integrate seamlessly with your
                    law firm's existing communication channels and workflow. The
                    AI enhances your current systems without disrupting them,
                    whether your intake operations are managed in-house or
                    through a call center.
                  </p>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-583">
                    We provide a lightweight portal that captures all AI
                    activity with summary information that can be integrated
                    into any CRM, case management, or practice management
                    platform that your firm already uses.
                  </p>
                </div>
              </div>
              {/* Communication Channels Section */}
              <div className="mb-24 relative" data-id="element-584">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-585"></div>
                <div className="flex items-center mb-8" data-id="element-586">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-587">
                    <LinkIcon size={24} className="text-white" data-id="element-588" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-589">
                    Connect with Your{' '}
                    <span className="text-white" data-id="element-590">Communication Channels</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-591">
                  <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-592">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-593">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-594">
                        <MessageSquare size={24} className="text-white" data-id="element-595" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-596">
                        Website Chat
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-597">
                        Replace your current webchat widget with our intelligent
                        AI system that works alongside your team.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-598">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-599">
                        <Phone size={24} className="text-white" data-id="element-600" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-601">
                        Telephone System
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-602">
                        Our AI can handle calls through a dedicated telephone
                        number that integrates with your existing phone system.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-603">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-604">
                        <Mail size={24} className="text-white" data-id="element-605" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-606">
                        Email Integration
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-607">
                        Works with the email addresses your team already uses,
                        ensuring a consistent communication flow.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Prebuilt Integrations Section */}
              <div className="mb-24 relative" data-id="element-608">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-609"></div>
                <div className="flex items-center mb-8" data-id="element-610">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-611">
                    <Layers size={24} className="text-white" data-id="element-612" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-613">
                    Prebuilt <span className="text-white" data-id="element-614">Integrations</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-615">
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-616">
                    We currently have prebuilt integrations with several popular
                    legal software platforms, allowing for immediate deployment
                    and seamless data flow.
                  </p>
                  <div className="grid md:grid-cols-2 gap-8" data-id="element-617">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-618">
                      <div className="flex items-center mb-6" data-id="element-619">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-620">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-621">
                            FV
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-622">
                          Filevine
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Playfair_Display'] mb-4" data-id="element-623">
                        Comprehensive case management system integration
                        allowing for automatic case creation and document
                        management.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-624">
                      <div className="flex items-center mb-6" data-id="element-625">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-626">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-627">
                            LC
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-628">
                          LeadConnector
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Playfair_Display'] mb-4" data-id="element-629">
                        CRM integration for seamless lead tracking and
                        management throughout the client acquisition process.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-630">
                      <div className="flex items-center mb-6" data-id="element-631">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-632">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-633">
                            VS
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-634">
                          Vinesign
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Playfair_Display'] mb-4" data-id="element-635">
                        Electronic signature integration allowing for immediate
                        document signing during the intake process.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-636">
                      <div className="flex items-center mb-6" data-id="element-637">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-638">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-639">
                            GHL
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-640">
                          GoHighLevel
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Playfair_Display'] mb-4" data-id="element-641">
                        Marketing automation platform integration for enhanced
                        lead nurturing and client communication.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Custom Integration Section */}
              <div className="mb-24 relative" data-id="element-642">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-643"></div>
                <div className="flex items-center mb-8" data-id="element-644">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-645">
                    <Code size={24} className="text-white" data-id="element-646" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-647">
                    Custom <span className="text-white" data-id="element-648">Integrations</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-649">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm mb-8" data-id="element-650">
                    <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-651">
                      Beyond our prebuilt integrations, we can connect with any
                      software that provides APIs through custom integration.
                      Our team works with you to create tailored solutions that
                      fit your specific workflow.
                    </p>
                    <div className="grid md:grid-cols-3 gap-6" data-id="element-652">
                      <div className="bg-black/40 p-6 rounded-sm text-center" data-id="element-653">
                        <Database size={28} className="text-white mx-auto mb-4" data-id="element-654" />
                        <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-655">
                          Data Transfer
                        </h4>
                        <p className="text-zinc-400 text-sm font-['Playfair_Display']" data-id="element-656">
                          Seamless data flow between systems
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm text-center" data-id="element-657">
                        <RefreshCw size={28} className="text-white mx-auto mb-4" data-id="element-658" />
                        <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-659">
                          Workflow Automation
                        </h4>
                        <p className="text-zinc-400 text-sm font-['Playfair_Display']" data-id="element-660">
                          Trigger actions across platforms
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm text-center" data-id="element-661">
                        <LinkIcon size={28} className="text-white mx-auto mb-4" data-id="element-662" />
                        <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-663">
                          Custom Connectors
                        </h4>
                        <p className="text-zinc-400 text-sm font-['Playfair_Display']" data-id="element-664">
                          Built specifically for your needs
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Final CTA Section */}
              <div className="relative mb-20" data-id="element-665">
                <div className="absolute inset-0 bg-gradient-to-r from-zinc-900/50 via-zinc-800/50 to-zinc-900/50 rounded-sm blur" data-id="element-666"></div>
                <div className="relative bg-gradient-to-br from-zinc-900 to-zinc-800 p-10 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-667">
                  <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-668">
                    <div className="mb-6 md:mb-0 md:mr-8" data-id="element-669">
                      <div className="flex items-center mb-4" data-id="element-670">
                        <Calendar size={24} className="text-white mr-3" data-id="element-671" />
                        <h3 className="font-['Playfair_Display'] text-2xl font-light" data-id="element-672">
                          Schedule a Demo & Integration Call
                        </h3>
                      </div>
                      <p className="font-['Space_Grotesk'] text-white text-lg" data-id="element-673">
                        Let us show you how LexSquire can integrate with your
                        existing systems to create a seamless workflow.
                      </p>
                    </div>
                    <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-8 py-4 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center whitespace-nowrap" data-id="element-674">
                      Schedule Now
                      <ArrowRight size={18} className="ml-2" data-id="element-675" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-676" />
    </div>;
};